module.exports = __webpack_public_path__ + "static/media/branding-img29.57c55b3a.jpg";